import type { PageLoad } from './$types';

export const load: PageLoad = ({ params }) => {
  return {
    meta: {
      title: 'New Course',
      activeNav: 'courses',
      breadcrumbs: {
        activeTitle: 'New',
        items: [
          {
            title: 'Courses & Skills',
            href: '/admin/courses',
          },
        ],
      },
    },
  };
};
